import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppRoutes from 'constants/AppRoutes';
import { DATA_SET_PAGINATION_COUNT } from 'constants/dataSets';
import { useGetQuestionnaireDataQuery, useLazyGetQuestionnaireDetailsQuery } from 'store/slices/materialAssessment/apis/materialAssessmentApi';

import MARespondentSurveysView from './MARespondentSurveysView';

import type IQuestionnaireDetailsItem from 'store/slices/materialAssessment/interfaces/IQuestionnaireDetailsItem';
import type IQuestionnaireItem from 'store/slices/materialAssessment/interfaces/IQuestionnaireItem';

function MARespondentSurveys() {
  const navigate = useNavigate();
  const { recordId = '', surveyId = '', vcmId = '' } = useParams();
  const [offset, setOffset] = useState(0);
  const [items, setItems] = useState<IQuestionnaireItem[]>([]);

  const [openModal, setOpenModal] = useState(false);
  const [details, setDetails] = useState<IQuestionnaireDetailsItem | null>(null);

  const { data: questionnaireData, isFetching: isLoading } = useGetQuestionnaireDataQuery({
    maId: recordId,
    topicId: Number(surveyId),
    offset,
    valueChainMapId: Number(vcmId),
  });

  const [getQuestionnaireDetails] = useLazyGetQuestionnaireDetailsQuery();

  const hasMore = questionnaireData?.data?.meta.hasNext;

  const loadMore = () => {
    if (questionnaireData?.data.meta.hasNext) {
      setOffset((prev) => prev + DATA_SET_PAGINATION_COUNT);
    }
  };

  useEffect(() => {
    if (questionnaireData && questionnaireData?.data?.items.length > 0) {
      setItems((prev) => {
        const existingIds = new Set(prev.map((item) => item.id));
        const newItems = questionnaireData?.data?.items
          .filter((item) => !existingIds.has(item.id))
          .map((item) => ({ ...item, custom: true }));
        return [...prev, ...newItems];
      });
    }
  }, [questionnaireData]);

  const handleBack = () => {
    navigate(AppRoutes.materialityAssessmentIRORefinement.replace(':recordId', recordId));
  };

  const handleGetDetails = (id: number) => {
    getQuestionnaireDetails({
      maId: recordId,
      topicId: id,
    }).then((res) => {
      setDetails(res?.data?.data || null);
      setOpenModal(true);
    });
  };

  const handleCancelModal = () => {
    setOpenModal(false);
    setDetails(null);
  };

  const loading = isLoading;

  return (
    <MARespondentSurveysView
      loading={loading}
      isEmptyList={items.length === 0}
      handleBack={handleBack}
      items={items}
      onLoadMore={loadMore}
      hasMore={!!hasMore}
      handleGetDetails={handleGetDetails}
      openModal={openModal}
      handleCancelModal={handleCancelModal}
      details={details}
    />
  );
}

export default MARespondentSurveys;
